import styled from 'styled-components';

export const ScBadges = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  position: absolute;
  top: -4px;
  left: -4px;
  pointer-events: none;

  & .new {
    order: -1;
  }
`;

export const ScBottomBadges = styled.div`
  display: flex;
  position: absolute;
  bottom: 0;
  justify-content: end;
  flex-direction: column;
  align-items: center;
  width: 100%;
  color: #fff;

  .bottom-badge {
    backdrop-filter: none;
    width: 100%;
    border-radius: 0 0 12px 12px;
    padding: 12px 0 2px;
    font-size: 11px;
    font-style: normal;
    font-weight: bold;
    height: auto;
  }

  .hot-badge {
    background: linear-gradient(
      0deg,
      #f80d0d 0%,
      #f92f2f 44.23%,
      rgba(212, 48, 40, 0) 100%
    );
  }

  .cold-badge {
    background: linear-gradient(
      0deg,
      #51b6d1 0%,
      #4779d4 44.23%,
      rgba(71, 121, 212, 0) 100%
    );
  }
`;
